import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCg7-b0TXIbW1S8Nj-EXi-mPJ5Ndnx0MgA",
  authDomain: "holidayhomes-7a788.firebaseapp.com",
  databaseURL: "https://holidayhomes-7a788-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "holidayhomes-7a788",
  storageBucket: "holidayhomes-7a788.firebasestorage.app",
  messagingSenderId: "1071253919546",
  appId: "1:1071253919546:web:1cad5826d9ca337fc92203"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const rtdb = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
